import decryptEmail from '../lib/decrypt-email';

// decrypt email
const emailLinks = [...document.querySelectorAll('.email-link')];
emailLinks.forEach((item) => {
    item.setAttribute('href', `mailto:${decryptEmail(item.dataset.encryptEmail)}`);
});
